import { render, staticRenderFns } from "./WsDemoExamStatus.vue?vue&type=template&id=55f56f64&scoped=true"
import script from "./WsDemoExamStatus.vue?vue&type=script&lang=js"
export * from "./WsDemoExamStatus.vue?vue&type=script&lang=js"
import style0 from "./WsDemoExamStatus.vue?vue&type=style&index=0&id=55f56f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f56f64",
  null
  
)

export default component.exports